import { render } from "./Exhibitor.vue?vue&type=template&id=3d99faa0"
import script from "./Exhibitor.vue?vue&type=script&lang=js"
export * from "./Exhibitor.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\apps\\appKonferenceStudioW\\v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__